import {OnInit, ElementRef, Host, OnChanges, SimpleChanges} from '@angular/core';
import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import store from "../../../store/store.module";
import {FETCH_CONSTANTS_REQUESTED} from "../../../store/constant/list/list.actions";
import * as $ from "jquery";

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[translateConstantKey]'
})
export class ConstantTranslatorDirective implements OnInit, OnChanges {
  @Input() translateConstantKey: string;
  @Input() type: string;
  @Input() takeValueFrom?: string;

  public store = store;
  public valueToDisplay = this.translateConstantKey;
  constructor(public element: ElementRef) {
    if (!this.takeValueFrom) {
      this.takeValueFrom = 'value';
    }
  }

  setValueToDisplay() {
    let obj = (store as any).getState().Constant.list.objects[this.type];
    let newValueToDisplay = this.translateConstantKey;
    if (obj) {
      if (obj[this.translateConstantKey]) {
        newValueToDisplay = typeof obj[this.translateConstantKey][this.takeValueFrom] !== 'undefined' ? obj[this.translateConstantKey][this.takeValueFrom] : this.translateConstantKey;
      }
    }
    if (newValueToDisplay !== this.valueToDisplay) {
      this.valueToDisplay = newValueToDisplay;
      $(this.element.nativeElement).text(this.valueToDisplay);
    }
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.setValueToDisplay();
  }
}
